<div class="wow fadeIn"
     data-wow-duration="500ms">
   <div class="pageBanner news"></div>


   <div class="page-sub-section">
      <div class="contentBox">
         <div class="sectionTitle padding-b-30 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">
            News & Media
         </div>
         <ul class="brand-details-list team-list logo-list font-16 line-25">
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-220 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/The_Indian_Express.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">05 Apr 2022
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://indianexpress.com/article/cities/delhi/iit-delhi-gets-indoor-sports-complex-spread-over-2000-square-meters-7849071/"
                        target="_blank" class="proximaNovaSb font-18">
                        IIT-Delhi gets indoor sports complex spread over 2,000 square meters
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     The complex has four badminton courts, two squash courts, two table tennis halls, an open-air
                     theatre, office space, a conference room and a terrace garden.
                     <a href="https://indianexpress.com/article/cities/delhi/iit-delhi-gets-indoor-sports-complex-spread-over-2000-square-meters-7849071/"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/prn_cision_logo.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">22 Dec 2021
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.prnewswire.com/news-releases/group-one-closes-us150-million-equity-financing-round-led-by-guggenheim-investments-and-qatar-investment-authority-301450223.html"
                        target="_blank" class="proximaNovaSb font-18">
                        Group ONE Closes US$150 Million Equity Financing Round Led by Guggenheim Investments and Qatar
                        Investment Authority
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Group ONE Holdings ("ONE" or the "Company"), Asia's
                     largest global sports media platform and parent company of ONE Championship and ONE Esports, today
                     announced it has closed a US$150 million equity financing round led by two new global investors,
                     Guggenheim Investments ("Guggenheim"), the global asset management and investment advisory division
                     of Guggenheim Partners, and Qatar Investment Authority ("QIA") – who join other blue-chip
                     institutional investors in the Company.
                     <a href="https://www.prnewswire.com/news-releases/group-one-closes-us150-million-equity-financing-round-led-by-guggenheim-investments-and-qatar-investment-authority-301450223.html"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/iitd.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">6 Aug 2021
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://home.iitd.ac.in/show.php?id=36&in_sections=Press"
                        target="_blank" class="proximaNovaSb font-18">
                        IIT Delhi Establishes Chairs to Support Research in Microelectronics & VLSI Design and
                        Geotechnical & Geo-Environmental Engineering
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     IIT Delhi alumnus Mr Saurabh Mittal (B. Tech. in Electrical Engineering, 1995 Batch) has endowed
                     two Chairs in honour of Prof G.S. Visweswaran and Prof Manoj Datta at IIT Delhi.
                     <a href="https://home.iitd.ac.in/show.php?id=36&in_sections=Press"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/bloomberg.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">24 Jun 2021
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.bloomberg.com/news/articles/2021-06-24/deserve-valuation-tops-500-million-as-mastercard-ally-invest"
                        target="_blank" class="proximaNovaSb font-18">
                        Deserve Valuation Tops $500 Million as MasterCard and Ally Ventures Invest
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Deserve, a credit-card technology startup, raised $50 million from backers including Mastercard
                     Inc. and Ally Financial Inc.’s strategic investment arm, its chief executive officer said in an
                     interview.
                     <a href="https://www.bloomberg.com/news/articles/2021-06-24/deserve-valuation-tops-500-million-as-mastercard-ally-invest"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/businesswire.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">24 Jun 2021
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.businesswire.com/news/home/20210624005404/en/%C2%A0Deserve-Raises-50-Million
                     -Series-D-to-Drive-Credit-Card-Transformation-From-Plastic-to-Software-Platform-for-Payments-Rewards-and-Lending"
                        target="_blank" class="proximaNovaSb font-18">
                        Deserve Raises $50 Million Series D to Drive Credit Card Transformation From Plastic to Software
                        Platform for Payments, Rewards and Lending
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Mastercard, Ally Ventures, Goldman Sachs, Sallie Mae, Mission Holdings and other existing investors
                     participate in Funding Round
                     <a href="https://www.businesswire.com/news/home/20210624005404/en/%C2%A0Deserve-Raises-50-Million-
                     Series-D-to-Drive-Credit-Card-Transformation-From-Plastic-to-Software-Platform-for-Payments-Rewards-and-Lending"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-full wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/Global-FinTech-Series-LOGO_1.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">28 Apr 2021
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://globalfintechseries.com/fintech/deserve-launches-digital-first-card-on-mastercard-network-for-mobile-first-experience/"
                        target="_blank" class="proximaNovaSb font-18">
                        Deserve Launches Digital First Card on Mastercard Network for Mobile-First Experience
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Digital First Card creates entire new credit card experience and can be branded and deployed in
                     weeks by partners, retailers, and affinity groups
                     <a href="https://globalfintechseries.com/fintech/deserve-launches-digital-first-card-on-mastercard-network-for-mobile-first-experience/"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/forbes.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">7 Apr 2021
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.forbes.com/sites/timcasey/2021/04/07/how-a-former-software-startup-founder-hedge-fund-manager-launched-a-leading-professional-martial-arts-organization/?sh=6d0ff303316f"
                        target="_blank" class="proximaNovaSb font-18">
                        How A Former Hedge Fund Manager Launched ONE Championship, An MMA Promotion Pushing Into The
                        U.S.

                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Growing up in Thailand, Chatri Sityodtong loved training and competing in muay thai. Sityodtong
                     continued with muay thai as he moved to the United States to attend Tufts University for his
                     undergraduate studies, headed to Harvard Business School for his Master of Business
                     Administration degree, launched a startup software company and ran his own hedge fund.

                     <a href="https://www.forbes.com/sites/timcasey/2021/04/07/how-a-former-software-startup-founder-hedge-fund-manager-launched-a-leading-professional-martial-arts-organization/?sh=6d0ff303316f"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/et-cio.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">1 Apr 2021
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://cio.economictimes.indiatimes.com/news/corporate-news/winning-in-the-age-of-digital-author-nitin-seth-reveals-his-success-strategy/81812821"
                        target="_blank" class="proximaNovaSb font-18">
                        Winning in the Age of Digital: Author Nitin Seth reveals his success strategy
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     The author of Winning in the Age of Digital and the CEO of Incedo, Nitin Seth has mastered the art
                     of leveraging digital technology to take business strategy to the next level.
                     <a href="https://cio.economictimes.indiatimes.com/news/corporate-news/winning-in-the-age-of-digital-author-nitin-seth-reveals-his-success-strategy/81812821"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/everstone.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">3 Mar 2021
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.everstonecapital.com/2021/03/03/everstone-group-wins-back-to-back-awards-again/"
                        target="_blank" class="proximaNovaSb font-18">
                        Everstone Group Wins Back to Back Awards … AGAIN
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     The prestigious ‘Private Equity International’ (PEI) has again named Everstone Group as ‘Firm of
                     the Year – India’ and ‘Mid-Market Firm of the Year – Asia’ at PEI Awards 2020. The Group has won
                     these awards for ninth and the fourth time respectively since 2011. The PEI Awards are the largest
                     and most respected awards in the global private equity industry. With multiple categories for
                     selection, voters have the chance to vote for categories across Global awards, EMEA awards,
                     Americas awards, Asia-Pacific awards, and Secondaries awards.
                     <a href="https://www.everstonecapital.com/2021/03/03/everstone-group-wins-back-to-back-awards-again/"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/everstone.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">17 Dec 2020
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.everstonecapital.com/2020/12/17/renewable-energy-platform-ayana-hits-721-million-in-funding-as-cdc-niif-and-ggef-agree-to-inject-further-capital/"
                        target="_blank" class="proximaNovaSb font-18">
                        Renewable energy platform Ayana hits $721 million in funding as CDC, NIIF and GGEF agree to
                        inject further capital
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     CDC Group, the UK’s development finance institution and impact investor, National Investment and
                     Infrastructure Fund (NIIF), and EverSource Capital managed Green Growth Equity Fund (GGEF) today
                     announced additional equity funding of $70 million / £52 million, $284 million / £212 million and
                     $36 million /£27 million respectively in Ayana Renewable Power (Ayana), a leading Indian renewable
                     energy platform. The proposed transaction envisages NIIF to become the majority shareholder in
                     Ayana. The commitment is subject to final approval processes.*
                     <a href="https://www.everstonecapital.com/2020/12/17/renewable-energy-platform-ayana-hits-721-million-in-funding-as-cdc-niif-and-ggef-agree-to-inject-further-capital/"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <!--            <li class="">-->
            <!--               <div class="person-pic">-->
            <!--                  <div class="icon pic width-180 wow fadeInUp"-->
            <!--                       data-wow-duration="500ms" data-wow-delay="50ms">-->
            <!--                     <img src="assets/images/reuters.png" alt="">-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--               <div class="person-details line-25">-->
            <!--                  <div class="margin-b-15 font-14 sapientsansmedium light-color">15 Jun 2020</div>-->
            <!--                  <div class="margin-b-15 wow fadeInUp"-->
            <!--                       data-wow-duration="500ms" data-wow-delay="150ms">-->
            <!--                     <a href="https://www.reuters.com/article/one-championship-funding-idUSL4N2DT0JQ"-->
            <!--                        target="_blank" class="proximaNovaSb font-18">-->
            <!--                        CORRECTED-Mixed martial arts firm One Championship raises $70 mln, but cuts 20% of staff-->
            <!--                     </a>-->
            <!--                  </div>-->
            <!--                  <div class="margin-b-15 wow fadeInUp"-->
            <!--                       data-wow-duration="500ms" data-wow-delay="150ms">-->
            <!--                     SINGAPORE, June 16 (Reuters) - Asian mixed martial arts promotion firm One Championship said on-->
            <!--                     Monday had raised $70 million in a new funding round, but was cutting 20% of its staff - a move-->
            <!--                     which comes after not being able to stage events since February due to the coronavirus pandemic.-->
            <!--                     <a href="https://www.reuters.com/article/one-championship-funding-idUSL4N2DT0JQ"-->
            <!--                        target="_blank"-->
            <!--                        class="proximaNovaSb highlight-color font-15">More</a>-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--            </li>-->

            <li class="">
               <div class="person-pic">
                  <div class="icon pic wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/techcrunch.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">5 Nov 2019
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://techcrunch.com/2019/11/04/goldman-sachs-leads-50m-round-for-credit-card-platform-deserve/"
                        target="_blank" class="proximaNovaSb font-18">
                        Goldman Sachs leads $50M round for credit card platform Deserve

                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Deserve, a credit card startup helping young people establish themselves, as well as a cloud-based
                     credit card platform for businesses, has raised $50 million in a new round of Series C funding led
                     by Goldman Sachs, the company announced today. Others participating in the round include existing
                     investors Sallie Mae, Accel, Aspect Ventures, Pelion Venture Partners and Mission Holdings.
                     <a href="https://techcrunch.com/2019/11/04/goldman-sachs-leads-50m-round-for-credit-card-platform-deserve/"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/forbes.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">23 Aug 2019
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.forbes.com/sites/forbestechcouncil/2019/08/23/blockchain-still-shows-great-promise-after-the-hype/?fbclid=IwAR3qJ8-UdCUs9f34rLjd_GQ5TuBOfjyyrmHpia4IeDg47gimk7dWvY-XgSQ&sh=3e2aa2dd4ecb"
                        target="_blank" class="proximaNovaSb font-18">
                        Blockchain Still Shows Great Promise After The Hype
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     In recent years, promoters of blockchain have pushed the technology as a major disrupter to
                     existing digital payments and transactions systems. Indeed, it offers tremendous promise to
                     become a key building block of the digital economy, but the technology has fallen victim to
                     massive hype and irrational exuberance in past, driven largely over a Bitcoin-buying frenzy.
                     <a href="https://www.forbes.com/sites/forbestechcouncil/2019/08/23/blockchain-still-shows-great-promise-after-the-hype/?fbclid=IwAR3qJ8-UdCUs9f34rLjd_GQ5TuBOfjyyrmHpia4IeDg47gimk7dWvY-XgSQ&sh=3e2aa2dd4ecb"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-full wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/business-standard.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">7 May 2019
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.business-standard.com/article/pti-stories/industry-veterans-join-incedo-in-crucial-roles-119050700354_1.html"
                        target="_blank" class="proximaNovaSb font-18">
                        Industry Veterans Join Incedo in Crucial Roles
                     </a>
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     "I am excited to have Shailaja and Roger join the team. Both are strategic hires for Incedo,
                     bringing unique value towards building a world class tech and analytics firm," said Nitin Seth,
                     CEO, Incedo. "Shailaja brings deeps experience of working with hi-quality talent and building a
                     distinctive culture. Roger is an acknowledged industry thought leader. He will bring cutting
                     edge engineering expertise to our clients and to our platform development efforts," added Nitin.
                     <a href="https://www.business-standard.com/article/pti-stories/industry-veterans-join-incedo-in-crucial-roles-119050700354_1.html"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-220 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/technasia.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">8 Oct 2018
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.techinasia.com/championship-raises-166m-series-led-sequoia"
                        target="_blank" class="proximaNovaSb font-18">
                        One Championship raises $166m series D round led by Sequoia
                     </a>
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Singapore mixed martial arts (MMA) firm One Championship has raised US$166 million in a series D
                     round led by Sequoia Capital, it announced today. Other investors in this round include Temasek
                     Holdings and Greenoaks Capital. This brings the total amount that One Championship has raised to
                     over US$250 million.
                     <a href="https://www.techinasia.com/championship-raises-166m-series-led-sequoia"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/dealstreetasia.jpeg" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">13 Mar 2018
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.dealstreetasia.com/stories/one-championship-names-billionaire-entrepreneur-saurabh-mittal-vice-chairman-94209/"
                        target="_blank" class="proximaNovaSb font-18">
                        ONE Championship names billionaire entrepreneur Saurabh Mittal as vice chairman
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Saurabh Mittal, the billionaire entrepreneur who founded Mission Holdings, has joined Asia’s
                     largest global sports media property ONE Championship (ONE) as vice chairman, ONE said in a
                     statement on Tuesday.
                     <a href="https://www.dealstreetasia.com/stories/one-championship-names-billionaire-entrepreneur-saurabh-mittal-vice-chairman-94209/"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/prn_cision_logo.png" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">8 Nov 2017
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.prnewswire.com/in/news-releases/iit-delhi-honors-saurabh-mittal-chairman-of-incedo-and-mission-holdings-with-the-2017-distinguished-alumnus-award-656031493.html"
                        target="_blank" class="proximaNovaSb font-18">
                        I.I.T Delhi Honors Saurabh Mittal, Chairman of Incedo and Mission Holdings, With the 2017
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     The Indian Institute of Technology, New Delhi, conferred the 2017 Distinguished Alumnus Award on
                     Saurabh Mittal, Chairman of Incedo and Mission Holdings, for exceptional achievement and
                     contribution in the area of Corporate Business Development and Entrepreneurship.

                     <a href="https://www.prnewswire.com/in/news-releases/iit-delhi-honors-saurabh-mittal-chairman-of-incedo-and-mission-holdings-with-the-2017-distinguished-alumnus-award-656031493.html"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
            <!--            <li class="">-->
            <!--               <div class="person-pic">-->
            <!--                  <div class="icon pic width-full wow fadeInUp"-->
            <!--                       data-wow-duration="500ms" data-wow-delay="50ms">-->
            <!--                     <img src="assets/images/bt-icon-black.svg" alt="">-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--               <div class="person-details line-25">-->
            <!--                  <div class="margin-b-15 font-14 sapientsansmedium light-color">27 May 2017</div>-->
            <!--                  <div class="margin-b-15 wow fadeInUp"-->
            <!--                       data-wow-duration="500ms" data-wow-delay="150ms">-->
            <!--                     <a href="https://www.businesstimes.com.sg/wealth-investing/firm-believer-in-longer-term-investments"-->
            <!--                        target="_blank" class="proximaNovaSb font-18">-->
            <!--                        Firm believer in longer-term investments-->
            <!--                     </a>-->
            <!--                  </div>-->
            <!--                  <div class="wow fadeInUp"-->
            <!--                       data-wow-duration="500ms" data-wow-delay="150ms">-->
            <!--                     Billionaire Saurabh Mittal, founder of Mission Holdings, gives a rare insight into his investment-->
            <!--                     strategies-->

            <!--                     <a href="https://www.prnewswire.com/in/news-releases/iit-delhi-honors-saurabh-mittal-chairman-of-incedo-and-mission-holdings-with-the-2017-distinguished-alumnus-award-656031493.html"-->
            <!--                        target="_blank"-->
            <!--                        class="proximaNovaSb highlight-color font-15">More</a>-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--            </li>-->
            <li class="">
               <div class="person-pic">
                  <div class="icon pic width-180 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">
                     <img src="assets/images/dealstreetasia.jpeg" alt="">
                  </div>
               </div>
               <div class="person-details line-25">
                  <div class="margin-b-15 font-14 sapientsansmedium light-color wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="50ms">19 May 2017
                  </div>
                  <div class="margin-b-15 wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     <a href="https://www.dealstreetasia.com/stories/saurabh-mittal-mission-holdings-72968/"
                        target="_blank" class="proximaNovaSb font-18">
                        Our thesis & structure allow us to make long term bets: Saurabh Mittal, Mission Holdings
                     </a>
                  </div>
                  <div class="wow fadeInUp"
                       data-wow-duration="500ms" data-wow-delay="150ms">
                     Saurabh Mittal, the founder and chairman of Mission Holdings and former vice-chairman and
                     co-founder of
                     Indiabulls, adopts a grounded investment approach that emphasises practical problem solving and
                     building organisations that can remain competitive market leaders in the long term.

                     <a href="https://www.dealstreetasia.com/stories/saurabh-mittal-mission-holdings-72968/"
                        target="_blank"
                        class="proximaNovaSb highlight-color font-15">More</a>
                  </div>
               </div>
            </li>
         </ul>
      </div>
   </div>

</div>
